import { getDB } from "src/db/databases"
import { useCacheStore } from "src/stores/cacheStore"
import { Log } from "src/util/classes/log"
import { getWorkDomainWorkspace } from "src/util/http/csi/workDomainsWorkspace"
import { WorkDomainWorkspace } from "src/util/types/dataModels/workDomain"

export async function getWorkDomainWorkspaceData(
  workDomainId: string
): Promise<WorkDomainWorkspace | undefined> {
  try {
    const cacheStore = useCacheStore()
    const workDomainInCache = cacheStore.work_domain_workspace.get(workDomainId)

    if (workDomainInCache) {
      // We have it in cache, return that
      return workDomainInCache
    } else {
      const db = await getDB()
      const workDomainInDb = await db.work_domain_workspace.findOne(workDomainId).exec()

      if (workDomainInDb) {
        // We have it in DB - return that and set it in the cache
        const workDomainMutable = workDomainInDb.toMutableJSON()
        cacheStore.work_domain_workspace.set(workDomainMutable.id, workDomainMutable)
        return workDomainMutable
      } else {
        // We get from the server and add it to the DB. Automatically set to cache on insert.
        const workDomain = await getWorkDomainWorkspace({}, workDomainId)
        await db.work_domain_workspace.insert(workDomain)
        return workDomain
      }
    }
  } catch (error) {
    Log.error({
      message: "An error occurred while fetching Work Domain Workspace data",
      error,
    })
  }
}
